import React from 'react';
import {connect} from 'react-redux';

import AudioPlayer from 'components/AudioPlayer';

import strings from 'utils/strings';

// import './styles.scss';

import audioNo from 'assets/sounds/no/6 1 Ordforstaelse Intro.mp3';
import audioNn from 'assets/sounds/nn/6 1 Ordforstaelse Intro.mp3';
import audioNoNorming from '../../assets/sounds/adult/ordforstaelse/no/Ny-introduksjon-til-Ordforstaels.mp3';
import audioNnNorming from '../../assets/sounds/adult/ordforstaelse/nn/Ny-introduksjon-til-Ordforstaels.mp3';

import tutorialVideo from './assets/e845140cdea968bfb0a8144fb06a7064.mp4';

const audioObj = {
	no: audioNo,
	nn: audioNn,
};
const normingLanguageObj = {
	no: audioNoNorming,
	nn: audioNnNorming,
};
class Intro extends React.Component {
	constructor(props) {
		super(props);
		const isDldTest = this.props.isDldTest ? 1 : 0;

		this.audio =
			isDldTest === 1
				? normingLanguageObj[strings.getLanguage()]
				: audioObj[strings.getLanguage()];
	}

	render() {
		const {onNextStep, isDldTest} = this.props;

		let videoRef;

		return (
			<div>
				<div className={isDldTest ? 'text-center' : 'text-left'}>
					<p>
						<AudioPlayer
							autoplay
							inline
							onPause={() => {
								videoRef.play();
							}}
							onErrorPlay={() => {
								console.log('Something went wrong');
							}}
							src={this.audio}
						/>
						{isDldTest
							? strings.ordforstaelseNormingIntro
							: strings.ordforstaelseIntro}
					</p>
					<p>
						{isDldTest
							? strings.ordforstaelseNormingTimelimit
							: strings.ordforstaelseTimelimit}
					</p>
				</div>
				<div className="lit-preview">
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={tutorialVideo}
					/>
				</div>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
